<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15dtqcs/tc-custom/9781466807334.jpg?1728724893891" alt="This image is the cover for the book Unspoken, Anders Knutas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unspoken, Anders Knutas
      </h1>
      <p class="bookDescription body article font2">
        <p>It is winter on Gotland, and fourteen-year-old Fanny is missing. She had no friends to speak of other than the horses she took care of at the local racing stable, and seems to have been an unhappy and isolated teenager, the daughter of an absent Jamaican musician and an instable Swedish mother. Is her disappearance somehow connected to the recent brutal murder of alcoholic photographer Henry Dahlström, who had won a large sum of money at the racetrack right before his death? Inspector Anders Knutas and his team investigate under pressure from the media.<br/><br/>Fanny is finally found, strangled to death and left on a lonely heath, covered by moss and branches. At the same time, grainy but explicit photographs of the girl with a stranger are discovered, hidden in Dahlström's darkroom. Intrepid TV journalist Johan Berg, sent from Stockholm to cover the two deaths, pushes the investigation one decisive step ahead while still trying to resolve his relationship with Emma, which has been simmering since they first met during the investigation into a series of murders on Gotland this past summer.<br/><br/>All evidence points to one of Fanny's coworkers at the stable, an American who has left the country for a short vacation. As Knutas and his team wait for his return to make the arrest, the inspector takes a well-deserved weekend off with an old friend, and at the lonely cottage in the woods, the pieces finally fit together. But this time, Knutas has gotten too close. . . .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mari Jungstedt
      </h2>
      
      <p class="authorDescription body article"><P>Mari Jungstedt has worked as a radio and television journalist for fourteen years. This is her second mystery in a series set on the island of Gotland off the coast of Sweden, where the author spends her summers. The rest of the year Mari lives in Stockholm with her family. She is currently at work on her fifth book.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Minotaur
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f375cea8